import { Component } from '@angular/core';

@Component({
  selector: 'bst-frontend-order-paid-modal',
  templateUrl: './order-paid-modal.component.html',
  styleUrls: ['./order-paid-modal.component.css'],
})
export class OrderPaidModalComponent {}
